export default "/images/vendor/quill/icons/outdent.svg?dd7145d26d6ba4aed3ebd11dc181d507";